import { render, staticRenderFns } from "./time-table.vue?vue&type=template&id=53145cdc&scoped=true"
import script from "./time-table.vue?vue&type=script&lang=js"
export * from "./time-table.vue?vue&type=script&lang=js"
import style0 from "./time-table.vue?vue&type=style&index=0&id=53145cdc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53145cdc",
  null
  
)

export default component.exports